import { BlockVariant, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { Injectable } from '@angular/core';

interface getPreDraftAoBlocksProps {
  save?: () => void;
  rest?: () => void;
}

interface getCreatedAoBlocksProps {
  update?: () => void;
  rest?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface getInspectAoBlocksProps {}

@Injectable({
  providedIn: 'root',
})
export class AoWorkflowBlocksService {
  getPreDraftAoBlocks({ save, rest }: getPreDraftAoBlocksProps): DynamicBlocks[] {
    const saveButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Enregistrer',
        onClick: () => save?.(),
      },
    };
    const resetButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Réinitialiser',
        onClick: rest,
        severity: 'secondary',
      },
    };
    return [
      {
        '1': [saveButton],
        '2': [resetButton],
      },
    ];
  }

  getCreatedAoBlocks({ update, rest }: getCreatedAoBlocksProps): DynamicBlocks[] {
    const updateButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Mettre à jour',
        onClick: () => update?.(),
      },
    };
    const resetButton: DynamicBlock = {
      variant: BlockVariant.BUTTON,
      props: {
        label: 'Réinitialiser',
        onClick: rest,
        severity: 'secondary',
      },
    };
    return [
      {
        '1': [updateButton],
        '2': [resetButton],
      },
    ];
  }

  getInspectAoBlocks(): DynamicBlocks[] {
    return [];
  }
}
